module.exports = __webpack_public_path__ + "static/media/clock2.a38e6cfc.svg";